import { withInstall } from '@xzx-design/utils'
import _Progress from './src/progress'

export const Progress = withInstall(_Progress)
export default Progress

export * from './src/progress'
export * from './src/types'
